var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusOg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1586 0.909668H12.8415V13.7516H-0.000488224L-0.000488281 15.0687L12.8415 15.0687V27.9101H14.1586V15.0687L26.9999 15.0687V13.7516H14.1586V0.909668Z",
    fill: "#FF5A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusOg);
export default __webpack_public_path__ + "static/media/Plus_og.fe5d936abedbcf953fbd2ed00884a8b7.svg";
export { ForwardRef as ReactComponent };